import type { ComponentByScreen } from '@/types/screens';
import { DrawerScreen } from '@/types/screens';
import { SavedCardList } from '@/components/SavedCardList/SavedCardList';
import { AddNewCardForm } from '@/components/AddNewCardForm/AddNewCardForm';
import { OtherPaymentMethodsList } from '@/components/OtherPaymentMethodsList/OtherPaymentMethodsList';

export const COMPONENT_BY_SCREEN: ComponentByScreen = {
  [DrawerScreen.OTHER_PAYMENT_METHOD]: OtherPaymentMethodsList,
  [DrawerScreen.SAVED_CARDS]: SavedCardList,
  [DrawerScreen.NEW_CARD]: AddNewCardForm,
};
